import { jsxs, jsx } from "react/jsx-runtime";
const IconPropertyHouseSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M11.028 2.253a1.99 1.99 0 0 1 1.944 0l8.514 4.765c.483.27.656.884.388 1.37a.996.996 0 0 1-1.36.391L20 8.491v3.612c1.165.415 2 1.531 2 2.846 0 1.316-.835 2.43-2 2.846v2.19h1c.552 0 1 .452 1 1.008S21.552 22 21 22H3c-.552 0-1-.45-1-1.007 0-.556.448-1.007 1-1.008h1V8.491l-.514.288a.997.997 0 0 1-1.36-.391 1.012 1.012 0 0 1 .389-1.37l8.513-4.765ZM6 7.373v12.612h3V14.95c0-.556.448-1.006 1-1.006h4l.102.004c.505.052.898.481.898 1.002v5.036h3v-2.19a3.018 3.018 0 0 1-2-2.846c0-1.315.835-2.431 2-2.846v-4.73l-6-3.358-6 3.357Zm5 12.612h2v-4.029h-2v4.03Zm8-6.042c-.552 0-1 .45-1 1.006 0 .557.448 1.007 1 1.007s1-.45 1-1.007c0-.556-.448-1.006-1-1.006Z" })
    ]
  }
);
export {
  IconPropertyHouseSvg
};
